import userRoles from '../utils/userRoles';

const addUserShape = new Map();

addUserShape.set('email', {
  width: '16',
  placeholder: 'common.email',
  label: 'common.email',
  required: true,
});

addUserShape.set('role', {
  width: '16',
  kind: 'select',
  label: 'usersConfig.role',
  placeholder: 'usersConfig.role',
  // FIXME make this a list instead, and convert to translated values (new utils?)
  options: userRoles.map(role => ({
    key: role,
    text: role,
    value: role,
  })),
  required: true,
});

export default addUserShape;



// WEBPACK FOOTER //
// ./src/shapes/addUserShape.js